import { render, staticRenderFns } from "./InsuranceCompanyCrud.vue?vue&type=template&id=005b765f&scoped=true&"
import script from "./InsuranceCompanyCrud.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyCrud.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceCompanyCrud.vue?vue&type=style&index=0&id=005b765f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005b765f",
  null
  
)

export default component.exports